import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { ApplicationEmptyState } from 'core/components';
import { PreviewLayout } from 'core/layouts';
import { AutoComplete } from "@progress/kendo-react-dropdowns";
import _ from 'lodash';

function FacilityMissingDocsSearchTemplate({ facilityMissingDocsSearchViewStore, t }) {
    const {
        loaderStore,
        facilityStore,
        setFacilityName
    } = facilityMissingDocsSearchViewStore;

    return (
        <PreviewLayout className="container container--new-flow" store={facilityMissingDocsSearchViewStore} emptyRenderer={<ApplicationEmptyState />} layoutFooterVisible={false} loading={loaderStore.loading}>
            <div className='container--missing-docs'>
                <label className='search-label'>{t('FACILITY_MISSING_DOCS.SEARCH.TITLE')}</label>
                <AutoComplete
                    className='search-input'
                    data={_.filter(facilityStore.items, i => i.hideInDropdown !== true).map((i) => { return i.name })}
                    onClose={() => facilityStore.onClose()}
                    onChange={(e) => { facilityStore.onFilter(e.target.value); setFacilityName(e.target.value); }}
                    placeholder={t('FACILITY_MISSING_DOCS.SEARCH.SEARCH_FACILITY_PLACEHOLDER')}
                />
            </div>
        </PreviewLayout >
    )
}

FacilityMissingDocsSearchTemplate.propTypes = {
    facilityMissingDocsSearchViewStore: PropTypes.object.isRequired,
    t: PropTypes.func
};

export default defaultTemplate(FacilityMissingDocsSearchTemplate);